import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';
import updateImplementationsCache from './updateImplementationsCache';

import type { RentersImplementationCreateMutation, RentersImplementationUpdateMutation } from '@/graphql/generated/graphql';

const rentersImplementations: UpdatesConfig['Mutation'] = {
  rentersImplementationCreate: (
    data: Data,
    _: Variables,
    cache: Cache,
  ) => {
    invalidateQuery('rentersImplementations', cache);
    const data2 = data as RentersImplementationCreateMutation;
    updateImplementationsCache(cache, data2.rentersImplementationCreate.ref_code_id);
  },
  rentersImplementationUpdate: (data: Data, __: Variables, cache: Cache) => {
    const data2 = data as RentersImplementationUpdateMutation;
    updateImplementationsCache(cache, data2.rentersImplementationUpdate.ref_code_id);
  },
};

export default rentersImplementations;
